import { createClient } from '@sanity/client';

const projectId = import.meta.env.VITE_SANITY_PROJECT_ID;
const dataset = import.meta.env.VITE_SANITY_DATASET;

if (!projectId) {
  throw new Error('Missing VITE_SANITY_PROJECT_ID in environment variables');
}

if (!dataset) {
  throw new Error('Missing VITE_SANITY_DATASET in environment variables');
}

export const client = createClient({
  projectId,
  dataset,
  useCdn: true,
  apiVersion: '2023-05-03',
  withCredentials: false,
});
